import { BasePlugin } from '../base'
import mdcFAB from './mdc-fab.vue'

export { mdcFAB }

export default BasePlugin({
  mdcFAB
})
